import { type ReactNode } from 'react';
import { Row, View } from '@amzn/stencil-react-components/layout';

export interface FieldPairProps {
  /** Left column content (one form field). */
  readonly left: ReactNode;
  /** Right column content (one form field). */
  readonly right: ReactNode;
}

/**
 * Lays two form fields side by side in a two-column row that wraps to a single
 * stacked column on narrow widths. Each side gets an equal-flex column
 * (`flex={1} minWidth={0}`), so related fields (e.g. Business Unit | Division)
 * use the horizontal space and fit within the page instead of each spanning a
 * full row. Purely presentational — the caller supplies the two fields.
 */
export function FieldPair({ left, right }: FieldPairProps): JSX.Element {
  return (
    <Row gridGap="dimensions.spacing.400" flexWrap="wrap" alignItems="flex-start">
      <View flex={1} minWidth={0}>
        {left}
      </View>
      <View flex={1} minWidth={0}>
        {right}
      </View>
    </Row>
  );
}
